















































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import { Vue, Component, Watch } from 'vue-property-decorator'
import { APIReportCategory } from '@/models/api/report-category.model'
import { APIReportDatasource } from '../../../models/api/report-datasource.model'
import { APIReportChartType } from '@/models/api/report-chart-type.model'
import { APIUser } from '@/models/api/user.model'

@Component
export default class ReportForm extends Vue {
    loading = true
    cardTitle = ''
    data: {[key: string]: unknown} = {}
    buttonLoading = false

    formData: {[key: string]: any} = {
        typeId: {
            id: null
        }
    }

    formModel: { categories: APIReportCategory[]; datasources: APIReportDatasource[]; chartTypes: APIReportChartType[]; users: APIUser[]} = {
        categories: [],
        datasources: [],
        chartTypes: [],
        users: []
    }

    formValid = false
    formRules = {
        required: [
            (v: string) => !!v || 'This field is required'
        ],
        reportName: [
            (v: string) => !!v || 'This field is required',
            (v: string) => (v && v.length <= 120) || 'Field must be less than 120 characters'
        ],
        reportDescription: [
            (v: string) => (v && v.length <= 250) || 'Field must be less than 250 characters'
        ]
    }

    @Watch('formData.reportChartEnabled')
    onReportChartEnabledChange () {
        if (!this.formData.reportChartEnabled) this.formData.chartTypeId = null
    }

    getData () {
        this.loading = true
        if (!this.$route.params.id) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not id sended in route params :(' })
            this.loading = false
            return
        }
        this.$store.dispatch('getReportsById', this.$route.params.id)
            .then(resp => {
                if (resp?.status === 200) {
                    this.formData = this.$store.state.ReportsStore.reportForm
                    this.formData.categoryId = this.$store.state.ReportsStore.reportForm.categoryId?.categoryId
                    this.formData.datasourceId = this.$store.state.ReportsStore.reportForm.datasourceId.datasourceId
                    this.formData.chartTypeId = this.$store.state.ReportsStore.reportForm.chartTypeId?.chartTypeId
                    this.formData.userId = this.$store.state.ReportsStore.reportForm.userId.userId
                    this.loading = false
                }
            })
    }

    getUsersFilter () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getUsersFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.users = resp.data.map((p: APIUser) => {
                            return {
                                text: p.username,
                                value: p.userId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getCategories () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getReportCategoriesFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.categories = this.$store.state?.FiltersStore?.reportCategoriesFilter?.map((p: APIReportCategory) => {
                            return {
                                text: p.categoryName,
                                value: p.categoryId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getDatasources () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getReporDatasourcesFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.datasources = this.$store.state?.FiltersStore?.reporDatasourcesFilter?.map((p: APIReportDatasource) => {
                            return {
                                text: p.datasourceName,
                                value: p.datasourceId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getReporChartTypes () {
        return new Promise<void>(resolve => {
            this.$store.dispatch('getReporChartTypesFilter')
                .then(resp => {
                    if (resp.status === 200) {
                        this.formModel.chartTypes = this.$store.state?.FiltersStore?.reporChartTypesFilter?.map((p: APIReportChartType) => {
                            return {
                                text: p.chartTypeName,
                                value: p.chartTypeId
                            }
                        })
                        resolve()
                    }
                })
        })
    }

    getDateFormat (dateString: string) {
        const date = new Date(dateString)
        const day = date.getDate().toString().padStart(2, '0')
        const month = date.getMonth().toString().padStart(2, '0')
        const year = date.getFullYear().toString().padStart(4, '0')
        const hours = date.getHours().toString().padStart(2, '0')
        const minutes = date.getMinutes().toString().padStart(2, '0')
        return `${day}/${month}/${year} - ${hours}:${minutes}`
    }

    async validateForm () {
        await (this.$refs.form as Vue & { validate: () => boolean }).validate()
        if (!this.formValid) return

        this.buttonLoading = true

        const data = {
            reportId: this.formData.reportId,
            categoryId: this.formData.categoryId,
            datasourceId: this.formData.datasourceId,
            reportChartEnabled: this.formData.reportChartEnabled,
            chartTypeId: this.formData.chartTypeId,
            reportDescription: this.formData.reportDescription,
            reportEnabled: this.formData.reportEnabled,
            reportName: this.formData.reportName,
            reportQuery: this.formData.reportQuery,
            reportPrivateEnabled: this.formData.reportPrivateEnabled,
            userId: this.formData.userId ? this.formData.userId : this.$store.state.AuthStore.auth.user.userId
        }

        switch (this.$route.params.action) {
        case 'edit':
            this.$store.dispatch('editReports', data)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Reports'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        case 'add':
            this.$store.dispatch('createReports', data)
                .then(resp => {
                    if (resp?.status === 200) {
                        this.$store.commit('reportSuccess', 'Done Successfully!')
                        this.$router.push({
                            name: 'Reports'
                        }).then(() => {
                            this.buttonLoading = false
                        })
                    }
                })
            break
        }
    }

    async mounted () {
        if (!this.$route.params.action) {
            this.$store.commit('reportError', { code: 1000, message: 'Error, not action sended in route params :(' })
            return
        }
        await this.getCategories()
        await this.getDatasources()
        await this.getReporChartTypes()

        switch (this.$route.params.action) {
        case 'edit':
            this.cardTitle = 'Edit Report'
            this.getData()
            this.getUsersFilter()
            break
        case 'add':
            this.cardTitle = 'Create Report'
            this.data = {}
            this.loading = false
            break
        }
    }
}
